import { Button, pxToRem, useStyles } from '@archipro-design/aria';
import React from 'react';
import * as S from './RefundPolicy.style';
import { useTracker } from '@archipro-website/tracker';
import RefundPolicyDialog from './RefundPolicyDialog';

export interface RefundPolicyData {
    Professional: {
        Title: string;
        Link: string;
    };
}

interface RefundPolicyProps {
    data: RefundPolicyData;
}

const RefundPolicy = ({ data }: RefundPolicyProps) => {
    const [refundModalOpen, setRefundModalOpen] = React.useState(false);
    const { css } = useStyles();
    const tracker = useTracker();

    return (
        <>
            <div
                className={css({
                    paddingTop: pxToRem(9),
                    textAlign: 'right',
                })}
            >
                <Button
                    onClick={() => {
                        tracker.log('ReturnsRefundsClick', {
                            url: new URL(window.location.href),
                            targetTracker: 'archiproTracker',
                        });
                        setRefundModalOpen(true);
                    }}
                    color="grey"
                    transparent
                    text
                    size={18}
                    className={css(S.ReturnTriggerButton)}
                    variables={{
                        buttonPadding: 0,
                    }}
                >
                    Return & Refunds Policy
                </Button>
                <RefundPolicyDialog
                    open={refundModalOpen}
                    close={() => setRefundModalOpen(false)}
                    data={data}
                />
            </div>
        </>
    );
};

export default RefundPolicy;
